import { convertFilterToSql } from './filterEditorHelpers'
import { fields } from "components/explore/resultsGrid/gridHelpers/fields";

function replaceFieldName(query, fields) {
  if (!query) return query;
  let newQuery = query;

  try {
  fields.forEach(field => {
    if (newQuery.includes(field.dataField)) {
      newQuery = newQuery.replaceAll(field.dataField, `[${field.caption}]`);
    }
  });
  } catch (e) {
    console.log(`Error while generating filter display. Value: ${newQuery}`)
  }

  return newQuery;
}

// function replaceOperators(query, multipleRows) {
//   if (!query) return query;

//   let newQuery = query;
//   const isEqual = newQuery.includes('=');
//   const isGreaterThanOrEqual = newQuery.includes('>=');
//   const isGreaterThan = newQuery.includes('>');
//   const isLessThan = newQuery.includes('<');
//   const isLessThanOrEqual = newQuery.includes('<=');
//   const isNotEqual = newQuery.includes('!=');
//   const isNotIn = newQuery.includes('NOT IN');
//   const isNull = newQuery.includes('IS NULL');
//   const isNotNull = newQuery.includes('IS NOT NULL');
//   const isEmpty = newQuery.includes("=''");
//   const isNotEmpty = newQuery.includes("!=''");
//   const isIn = /IN \(.{1,}\)/.test(newQuery);
//   const isContains = /LIKE \(\'\%{1}.{1,}\%\'\)/.test(newQuery);
//   const isStartsWith = /LIKE \(\'[^\%].{1,}\%\'\)/.test(newQuery);
//   const isEndsWith = /LIKE \(\'\%{1}[^\%]{1,}\'\)/.test(newQuery);
//   const isBetween = /BETWEEN [0-9]{1,} AND [0-9]{1,}/.test(newQuery);
//   const isNotBetween = /NOT BETWEEN [0-9]{1,} AND [0-9]{1,}/.test(newQuery);

//   if (isGreaterThanOrEqual) newQuery = newQuery.replaceAll('>=', 'Greater Than or Equal');
//   if (isGreaterThan) newQuery = newQuery.replaceAll('>', 'Greater Than');
//   if (isLessThan) newQuery = newQuery.replaceAll('<', 'Less Than');
//   if (isLessThanOrEqual) newQuery = newQuery.replaceAll('<=', 'Less Than or Equal');
//   if (isNotEqual) newQuery = newQuery.replaceAll('!=', 'Not Equal');
//   if (isNotIn) newQuery = newQuery.replaceAll('NOT IN', 'Not In');
//   if (isNull) newQuery = newQuery.replaceAll('IS NULL', 'Is Null');
//   if (isNotNull) newQuery = newQuery.replaceAll('IS NOT NULL', 'Is Not Null');
//   if (isEmpty) newQuery = newQuery.replaceAll("=''", 'Is Empty');
//   if (isNotEmpty) newQuery = newQuery.replaceAll("!=''", 'Is Not Empty');
//   if (isEqual) newQuery = newQuery.replaceAll('=', 'Equal');

//   if (isIn) {
//     newQuery = newQuery.replace(/IN \(.{1,}\)/, function(value) {
//       value = value
//         .replaceAll('IN', 'In')
//         .replaceAll('(', '')
//         .replaceAll(')', '');
//       return value;
//     });
//   }

//   if (isContains) {
//     newQuery = newQuery.replace(/LIKE \(\'\%{1}.{1,}\%\'\)/, function(value) {
//       value = value
//         .replaceAll('LIKE', 'Contains')
//         .replaceAll("('%", '')
//         .replaceAll("%')", '');
//       return value;
//     });
//   }

//   if (isStartsWith) {
//     newQuery = newQuery.replace(/LIKE \(\'[^\%].{1,}\%\'\)/, function(value) {
//       value = value
//         .replaceAll('LIKE', 'Starts With')
//         .replaceAll("('", '')
//         .replaceAll("%')", '');
//       return value;
//     });
//   }

//   if (isEndsWith) {
//     newQuery = newQuery.replace(/LIKE \(\'\%{1}[^\%]{1,}\'\)/, function(value) {
//       value = value
//         .replaceAll('LIKE', 'Ends With')
//         .replaceAll("('%", '')
//         .replaceAll("')", '');
//       return value;
//     });
//   }

//   if (isBetween) {
//     newQuery = newQuery.replace(/BETWEEN [0-9]{1,} AND [0-9]{1,}/, function(value) {
//       value = value
//         .replaceAll('BETWEEN', 'Between')
//         .replaceAll('AND', 'And');
//       return value;
//     });
//   }

//   if (isNotBetween) {
//     newQuery = newQuery.replace(/NOT BETWEEN [0-9]{1,} AND [0-9]{1,}/, function(value) {
//       value = value
//         .replaceAll('NOT BETWEEN', 'Not Between')
//         .replaceAll('AND', 'And');
//       return value;
//     });
//   }

//   if (multipleRows) {
//     if (/AND/.test(newQuery)) {
//       newQuery = newQuery.replaceAll('AND', '\n\r AND')
//     }

//     if (/OR/.test(newQuery)) {
//       newQuery = newQuery.replaceAll('OR', '\n\r OR')
//     }
//   }

//   return newQuery;
// }

export function prettifyFilterQuery(rules) {
  if (rules && Array.isArray(rules)) {
    if (typeof rules[0] === 'string' && typeof rules[1] === 'string') {
      return stringifyStructuredRules(rules);
    }
    const treatedRules = treatFilterRules(rules).reduce((prev, curr) => {
      let levelOfIdentation = 0;
      prev += stringifyStructuredRules(curr, prev, levelOfIdentation)
      return prev;
    }, '')
    return treatedRules
  }
}

export function prettifyFilterQueryWithoutIdentation(rules, multipleRows) {
  if (rules && Array.isArray(rules)) {
    if (typeof rules[0] === 'string' && typeof rules[1] === 'string') {
      return stringifyStructuredRulesWithoutIdentation(rules);
    }
    const treatedRules = treatFilterRules(rules).reduce((prev, curr) => {
      let levelOfIdentation = 0;
      prev += stringifyStructuredRulesWithoutIdentation(curr, prev, levelOfIdentation)
      return prev;
    }, '')
    return treatedRules
  }
}

const generateIdentationString = (levelOfIdentation, extraIdentation) => {
  const SPACES_PER_IDENDATION_LEVEL = 2;
  return `${"".padEnd(levelOfIdentation * SPACES_PER_IDENDATION_LEVEL + extraIdentation, " ")}`
}

const stringifyStructuredRules = (curr, prev, levelOfIdentation) => {
  if(Array.isArray(curr) && typeof curr[0] === 'string' && typeof curr[1] === 'string') {
    return `${generateIdentationString(levelOfIdentation > 0 ? levelOfIdentation + 1 : levelOfIdentation, 0)}${replaceFieldName(convertFilterToSql(curr), fields)}${curr[3] ? ` `+ curr[3]?.toUpperCase() : ''}\n`
  } else if(curr === 'and' || curr === 'or') return `${generateIdentationString(levelOfIdentation, 0)}${curr.toUpperCase()}\n`
  else {    
    let conditions = ''
    if(Array.isArray(curr)) {
      levelOfIdentation += 1; 
      conditions += `${generateIdentationString(levelOfIdentation, 0)}(\n`
      curr.forEach((v) => {
        conditions += stringifyStructuredRules(v, prev, levelOfIdentation)
      })
      conditions += `${generateIdentationString(levelOfIdentation, 0)})\n`
      levelOfIdentation -= 1; 
      return conditions;
    }
    return stringifyStructuredRules(curr, prev)
  }
}

const stringifyStructuredRulesWithoutIdentation = (curr, prev) => {
    if(Array.isArray(curr) && typeof curr[0] === 'string' && typeof curr[1] === 'string') {
      return `${replaceFieldName(convertFilterToSql(curr), fields)}${curr[3] ? ` `+ curr[3]?.toUpperCase() + ' ': ''}`
    } else if(curr === 'and' || curr === 'or') return ` ${curr.toUpperCase()} `
    else {    
      let conditions = ''
      if(Array.isArray(curr)) {
        conditions += `(`
        curr.forEach((v) => {
          conditions += stringifyStructuredRulesWithoutIdentation(v, prev)
        })
        conditions += `)`
        return conditions;
      }
      return stringifyStructuredRulesWithoutIdentation(curr, prev)
    }
}

const treatFilterRules = (rules) => {
  const rulesCopy = [...rules]
  return rulesCopy.reduce((prev, v) => {
    if ((v === 'and' || v === 'or') && prev.length > 0) {
      const topFromPrev = prev[prev.length - 1]
      if (Array.isArray(topFromPrev) && typeof topFromPrev[0] === 'string' && typeof topFromPrev[1] === 'string') {
        prev[prev.length - 1] = [...topFromPrev, v]
        return prev;
      }
    }
    const r = groupOperatorsWithExpression(v)
    prev.push(r)
    return prev;
  }, [])

}

const groupOperatorsWithExpression = (curr) => {
  if (curr === 'and' || curr === 'or') {
    return curr
  }
  if (Array.isArray(curr) && typeof curr[0] === 'string' && typeof curr[1] === 'string') {
    return curr;
  }
  else {
    const currCopy = [...curr]
    const ret =
    currCopy.reduce((prev, v) => {
        if ((v === 'and' || v === 'or') && prev.length > 0) {
          const topFromPrev = prev[prev.length -1]
          if (Array.isArray(topFromPrev) && typeof topFromPrev[0] === 'string' && typeof topFromPrev[1] === 'string') {
              prev[prev.length -1] = [...topFromPrev, v]
              return prev;
          }
        }
        const rslt = groupOperatorsWithExpression(v)
        prev.push(rslt)
        return prev;
      }, [])
    return ret
  }
}